import { Plugin } from "prosemirror-state";
import { customSchema } from "../../schemas/custom-schema";


export const customLinkUpdateAttribute = new Plugin({
  appendTransaction: (transactions, oldState, newState) => {
    if(!transactions.some(tr => tr.docChanged)) {
      return;
    }

    const markType = customSchema.marks.customLink;
    let tr = newState.tr,
      somethingChanged = false,
      notasEditorCount = 1,
      notasAutorCount = 1;

    newState.doc.nodesBetween(0, newState.doc.content.size, (node, pos) => {
      if(node.isInline && node.marks.length > 0) {
        node.marks.forEach(mark => {
          if(mark.type === markType) {
            const currentAttrs = mark.attrs,
              type = currentAttrs.type,
              newIndex = (type === "editor" ? notasEditorCount++ : notasAutorCount++),
              newAttrs = { index: newIndex, href: `#nota-${type}-${newIndex}`, type };

            if(currentAttrs.index !== newIndex) {
              const newMark = customSchema.marks.customLink.create(newAttrs),
                range = { from: pos, to: pos + node.nodeSize };

              tr.removeMark(range.from, range.to, markType);
              tr.addMark(range.from, range.to, newMark);
              somethingChanged = true;
            }
          }
        });
      }
    });

    if(somethingChanged) {
      return tr;
    }
  }
});